import { TInsertReservation } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const insertReservation = (payload: TInsertReservation) => {
  return API.post('api/accommodation/reservation', payload).then(res => res?.data);
};
